module.exports = __webpack_public_path__ + "static/media/Family.ee57c006.png";